<template>
	<section class="list-filters">
		<h3>{{ title }}</h3>
		<div class="list">
			<slot></slot>
		</div>
	</section>
</template>

<script>
export default {
	name: 'FilterCContainer',
	props: {
		title: {
			type: String,
			required: true
		}
	}
}
</script>

<style lang="scss" scoped>
.list-filters {
	background-color: #223244;
	padding: 16px 20px;
	border-radius: 5px;

	&:not(:last-of-type) {
		margin-bottom: 20px;
	}

	h3 {
		color: #7f868f;
		font-size: 1.1em;
		font-weight: 700;
		border-bottom: 1px solid #7f868f;
		padding-bottom: 6px;
		margin-bottom: 16px;
	}

	.list {
		max-height: 300px;
		overflow: auto;
		scrollbar-width: thin;
		.search {
			position: relative;
			justify-content: flex-end;
			display: flex;
			input {
				height: 35px;
				margin-bottom: 9px;
				width: 295px;
				padding-left: 10px;
			}
			i {
				position: absolute;
				color: #000;
				top: 10px;
				right: 11px;
			}
		}
		&::-webkit-scrollbar-track {
			background-color: #0003;
		}

		&::-webkit-scrollbar {
			width: 7px;
		}

		&::-webkit-scrollbar-thumb {
			background-color: #767C85;
		}
	}
}
</style>
